import React, { useState, useEffect } from "react";
import { Font } from "../../theme/Font";
import { styled, keyframes } from "styled-components";
import { useSelector } from "react-redux";
import { Description, Section112, SubTitle, TitleSection } from "../DesignComponent/DesignComponents";

const Customization = () => {
  const data = useSelector(
    (state) =>
      state?.continuousimprovementPage?.continuousimprovementPage?.acf
        ?.customization
  );
console.log(data);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isAnimate, setisAnimate] = useState(false);
  const [tabClicked, setTabClicked] = useState(false);

  const handleTabClick = (index) => {
    setTabClicked(true);
    setisAnimate(true);
    setSelectedTab(index);
  };

  const tabImages = data?.tabs?.map((item) => item.tab.image);

  const switchToNextTab = () => {
    if (!tabClicked) {
      const nextTab = (selectedTab + 1) % tabImages.length;
      setSelectedTab(nextTab);
    }
  };
  useEffect(() => {
    const delayTime = 5000;
    let timer;
    timer = setTimeout(switchToNextTab, delayTime);
    return () => clearTimeout(timer);
  }, [selectedTab, tabImages]);

  if (!tabImages || tabImages.length === 0) {
    return null;
  }

  return (
    <>
      <Section112>
        <div className="container">
          <div className="row text-center justify-content-center">
            <div className="col-lg-6">
              <SubTitle className="sub-title mb-2">
                {data?.text_before_title}
              </SubTitle>
              <TitleSection className="lh-1 mb-3">{data?.title}</TitleSection>
              <Description
                className="description mb-4"
              >
                {data?.description}
              </Description>
              {/* <Learnmore to={data?.learn_more_link?.url}>
                <span className="me-2">{data?.learn_more_link?.title}</span>
                <img
                  src={forwardicon}
                  alt={"forwardicon"}
                  style={{ width: "24px", height: "24px" }}
                />
              </Learnmore> */}
            </div>
          </div>
          <InnerSection>
            <div className="row">
              <div className="col-12 d-flex overflow-auto">
                {data?.tabs?.map((item, index) => (
                  <div
                    key={index}
                    className={`tab-title bg-darkBeige text-center w-100 d-flex flex-wrap justify-content-center ${
                      selectedTab === index ? " active" : ""
                    }`}
                    onClick={() => handleTabClick(index)}
                  >
                    <TabTitle className="sub-title py-3 mb-0">
                      {item?.tab?.title}
                    </TabTitle>
                    <HScrollLine
                      style={
                        selectedTab === index && isAnimate
                          ? { background: "#1C1C4B" }
                          : {}
                      }
                      className={selectedTab === index ? "active" : ""}
                    />
                  </div>
                ))}
              </div>
              <div className="col-12">
                <img
                  src={tabImages[selectedTab]}
                  alt={data?.tabs[selectedTab]?.tab?.title}
                  className="w-100"
                  // style={{ maxHeight: "600px" }}
                />
              </div>
            </div>
          </InnerSection>
        </div>
      </Section112>
    </>
  );
};

export default Customization;

const InnerSection = styled.section`
  padding-top: 120px;
  @media (max-width: 991px) {
    padding-top: 40px;
  }
`;
const TabTitle = styled.p`
  font-size: 18px;
  font-family: ${Font.basel};
  font-weight: bold;
  @media (max-width: 767px) {
    font-size: 14px;
  }
`;
// const Learnmore = styled(Link)`
//   font-size: 18px;
//   font-family: ${Font.basel};
//   color: #000;
//   text-decoration: none;
//   font-weight: bold;
// `;

const moveAnimation = keyframes`
0% {
background-position: 100% 0%;
}
100% {
background-position: 0% 0%;
}
`;

const HScrollLine = styled.span`
  border-radius: 0px;
  width: 100%;
  display: inline-block;
  height: 3px;
  background: linear-gradient(
    90deg,
    #1c1c4b 0%,
    #1c1c4b 50%,
    #c3c9d5 0%,
    #c3c9d5 100%
  );
  background-size: 200% 100%;
  background-position: 100% 0%;
  transition: background-position 0.5s ease;
  &.active {
    animation: ${moveAnimation} 5s infinite;
  }
`;
